module.exports = __webpack_public_path__ + "static/96250363-a9d58cb8871fce9706d8ffb75308ba93.jpg";